import { themeIcons } from "config/theme";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import VIcon from "components/custom/Icon";
import { useDispatch, useSelector } from "react-redux";
import PaginationBar from "../../../components/custom/PaginationBar";
import { ApiKey, ApiUrl, AlertTypes } from "util/Constant";
import ApiEngine from "util/ApiEngine";
import { showResponseMessage, setSpinWheelListModal, setSpinWheelReportModal, showMessage, setBusy, setIdle } from "redux/AppAction";
import { find } from "lodash";
import { numberWithCurrencyFormat, stringIsNullOrEmpty } from "../../../util/Util";
import { buttonDisabledCheck } from "util/gameUtil";
import moment from "moment";
import SpinWheelClaimRecordPopUp from "./SpinWheelClaimRecordPopUp";



const SpinWheelListPopUpModal = (props) => {
  var { t } = useTranslation();
  var _dispatch = useDispatch();

  const [paginationPageNum, setPaginationPageNum] = useState(10);
  const [isResetCurrentPage, setIsResetCurrentPage] = useState(false);
  const walletsDetails = useSelector((state) => state.appState.walletsDetails);
  var { heartBeat } = useSelector((state) => state.authState);
  const [utcTimeForTooltip, setUtcTimeForTooltip] = useState();

  const rewardType = useSelector((state) => state.appState.rewardType);
  const spinWheelListModal = useSelector((state) => state.appState.spinWheelListModal);
  const [isLoadingList, setIsLoadingList] = useState(true);
  const [spinWheelList, setSpinWheelList] = useState([]);
  const companyIcons = useSelector((state) => state.appState.companyIcons);
  const [coinIcon, setCoinIcon] = useState();
  const [emptyPromoIcon, setEmptyPromoIcon] = useState();
  const [iframeSrc, setIframeSrc] = useState('');
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [shouldShowReward, setShouldShowReward] = useState(false);
  const [modalName, setModalName] = useState("Reward");

  const firstLoad = useRef(false);
  const intervalRef = useRef(null); // Ref to track the interval
  const hasShownError = useRef(false); // Ref to track if the error message has been shown
  const pageReqCache = useRef(1);
  const [isRewardClaimModalOpen, setIsRewardClaimModalOpen] = useState(false);
  const modalBodyRef = useRef(null); // use to scroll top once click a reward

  const [alertIcon, setAlertIcon] = useState("");

  const oneWallet = useSelector((state) => state.appState.oneWallet);
  const isPromoActive = useSelector((state) => state.appState.walletsDetails.isActivedPromoExist);
  const apiControllerRef = useRef(null);
  const fetchSessionRef = useRef(0);
  const forceWithdraw = useSelector(
    (state) => state.appState.walletsDetails.forceWithdraw
  );



  useEffect(() => {
    const utcTimezone = moment.utc().format("h:mm:ss A");
    setUtcTimeForTooltip(utcTimezone);
    firstLoad.current=true;
  }, []);

  useEffect(() => {
    const element = document.querySelector(".modal");
    if (!element) return;

    if (isRewardClaimModalOpen) {
      element.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      const timeoutId = setTimeout(() => {
        element.style.overflow = "hidden"; // Disable scroll for iframe modal
      }, 300);

      return () => {
        clearTimeout(timeoutId);
        element.style.overflow = "auto";
      };
    }

    element.style.overflow = "auto"; // Restore scroll
  }, [isRewardClaimModalOpen]);

useEffect(() => {
  let isActive = true;
  let timerId;

  if (spinWheelListModal && rewardType.id > 0) {
    const fixedId = rewardType.id; // <-- lock the current ID
    const sessionId = ++fetchSessionRef.current;

    const loopFetch = async () => {
      if (!isActive || isAbandoned.current) return;

      await getMySpins(fixedId, pageReqCache.current, sessionId);

      timerId = setTimeout(loopFetch, 10000);

    };

    firstLoad.current = true;
    isAbandoned.current = false;
    hasShownError.current = false;
    pageReqCache.current = 1;
    loopFetch();

    return () => {
        clearTimeout(timerId);
        isActive = false;
        isAbandoned.current = true;
        isFetching.current = false;
        if (apiControllerRef.current) {
          apiControllerRef.current.abort();
          apiControllerRef.current = null;
        }
    };
  }

  return () => {
    isActive = false;
    isAbandoned.current = true;
    isFetching.current = false;
    clearTimeout(timerId);
    if (apiControllerRef.current) {
      apiControllerRef.current.abort();
      apiControllerRef.current = null;
    }
  };
}, [spinWheelListModal]);

  useEffect(() => {

    if (spinWheelListModal && heartBeat && rewardType.id > 0) {
      //setIsLogin(true);
      init();
    }
  }, [spinWheelListModal]);

  useEffect(() => {
    if (companyIcons.length > 0) {
      getCompanyIcon();
    }
  }, [companyIcons]);

  async function getCompanyIcon() {
    const coinIcon = find(companyIcons, { iconCategory: "coin_icon" });
    if (coinIcon) {
      setCoinIcon(coinIcon.iconImage || coinIcon.defaultImage);
    }

    const emptyPromoIcon = find(companyIcons, { iconCategory: "empty_promotion" });
    if (emptyPromoIcon) {
      setEmptyPromoIcon(emptyPromoIcon.iconImage || emptyPromoIcon.defaultImage);
    }

    const alert = find(companyIcons, { iconCategory: "alert" });
    if (alert) {
      setAlertIcon(alert.iconImage||alert.defaultImage);
    }
  }

  const spinWheelSetting = useSelector(
    (state) => state.appState.spinWheelSetting
  );

  // async function init() {
  //   // Get spinwheel settings
  //   let responseJson = await ApiEngine.get(
  //     ApiUrl._API_GET_SPINWHEEL_SETTINGS
  //   );

  //   if (responseJson[ApiKey._API_SUCCESS_KEY]) {
  //     var spinWheelEnabled = false;
  //     var showSpinWheelForGuest = false;

  //     if (responseJson[ApiKey._API_DATA_KEY].spinWheelEnabled == "1") {
  //       spinWheelEnabled = true;
  //     }

  //     if (responseJson[ApiKey._API_DATA_KEY].showSpinWheelForGuest == "1") {
  //       showSpinWheelForGuest = true;
  //     }

  //     if (heartBeat && spinWheelEnabled) {
  //       setShouldShowSpinWheel(true);
  //     } else if (!heartBeat && spinWheelEnabled && showSpinWheelForGuest) {
  //       setShouldShowSpinWheel(true);
  //     }
  //   }
  // }

    async function init() {
    // Get spinwheel settings
    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_REWARD_SETTINGS_BY_TYPE + "?typeId=" + rewardType.id
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      var rewardEnabled = false;
      var showForGuest = false;

      if (responseJson[ApiKey._API_DATA_KEY].status) {
        rewardEnabled = true;
      }

      if (responseJson[ApiKey._API_DATA_KEY].showForGuest) {
        showForGuest = true;
      }

      if (heartBeat && rewardEnabled) {
        setShouldShowReward(true);
      } else if (!heartBeat && rewardEnabled && showForGuest) {
        setShouldShowReward(true);
      }

      //setModalName(responseJson[ApiKey._API_DATA_KEY].typeName)
    }
  }


  // async function getMySpins(page) {
  //   try {
  //     if (firstLoad.current) {
  //       _dispatch(setBusy());
  //       setIsLoadingList(true);
  //     }

  //     page = page ? page : 1;
  //     const itemsPerPage = 10;
  //     var start = (page - 1) * itemsPerPage;
  //     const end = start + itemsPerPage;

  //     var apiUrl = ApiUrl._API_GET_MEMBER_SPINS +
  //       "?start=" + start + "&count=" + itemsPerPage;

  //     let responseJson = await ApiEngine.get(apiUrl);
     
  //     if (responseJson[ApiKey._API_SUCCESS_KEY]) {

  //       var paginatedData = responseJson[ApiKey._API_DATA_KEY][ApiKey._API_DATA_KEY];

  //       for (var i = 0; i < paginatedData.length; i++) {
  //         paginatedData[i]["expiryDateTxt"] = calculateTimeLeft(paginatedData[i]["expiryDate"]);
  //       };

  //       setSpinWheelList(paginatedData);
  //       var totalCount = responseJson[ApiKey._API_DATA_KEY].totalCount;
  //       updatePageinationPageNum(Math.ceil(totalCount / itemsPerPage));
  //     } else {
  //       _dispatch(
  //         showResponseMessage(false, "ERROR_LOADING_MY_SPINS")
  //       );

  //       // If an error occurs, handle the interval clearing logic
  //       if (!hasShownError.current) {
  //         hasShownError.current = true; // Mark the error as shown
  //         clearInterval(intervalRef.current); // Clear the interval
  //         _dispatch(showResponseMessage(false, "ERROR_LOADING_MY_SPINS"));
  //       }
  //     }

  //     if (firstLoad.current) {
  //       _dispatch(setIdle());
  //       setIsLoadingList(false);
  //       firstLoad.current = false;
  //     }
  //   } catch (err) {
  //     _dispatch(showResponseMessage(false, err));
  //   }
  //   return;
  // }

 const isFetching = useRef(false);
 const isAbandoned = useRef(false);

   async function getMySpins(typeId, page, sessionId = fetchSessionRef.current) {
  if (isFetching.current) return;
  isFetching.current = true;

  let controller;
  try {
    if (firstLoad.current) {
      _dispatch(setBusy());
      setIsLoadingList(true);
    }

    if (typeId <= 0) {
      _dispatch(showResponseMessage(false, "Reward Type Unknown"));
      return;
    }

    controller = new AbortController();
    apiControllerRef.current = controller;

    const apiUrl = `${ApiUrl._API_GET_MEMBER_CAMPAIGNS}?typeId=${typeId}&start=${(page - 1) * 10}&count=10`;

    const responseJson = await ApiEngine.get(apiUrl, { signal: controller.signal });

    const isStaleRequest =
      sessionId !== fetchSessionRef.current ||
      isAbandoned.current ||
      controller.signal.aborted ||
      apiControllerRef.current !== controller;

    if (isStaleRequest) return;

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      const data = responseJson[ApiKey._API_DATA_KEY][ApiKey._API_DATA_KEY];
      data.forEach(item => (item.expiryDateTxt = calculateTimeLeft(item.expiryDate)));

      setSpinWheelList(data);
      const totalCount = responseJson[ApiKey._API_DATA_KEY].totalCount;
      updatePageinationPageNum(Math.ceil(totalCount / 10));
    } else {
      if (!hasShownError.current) {
        hasShownError.current = true;
        _dispatch(showResponseMessage(false, "ERROR_LOADING_MY_SPINS"));
      }
    }
  } catch (err) {
       const isCanceled =
      err.name === "AbortError" ||
      err.message?.toLowerCase().includes("aborted") ||
      err.message?.toLowerCase().includes("canceled");

    const isStaleRequest =
      sessionId !== fetchSessionRef.current ||
      isAbandoned.current ||
      controller?.signal?.aborted;

    if (!isCanceled && !isStaleRequest) {
      _dispatch(showResponseMessage(false, err.message || "ERROR_LOADING_MY_SPINS"));
    }
  } finally {
    if (apiControllerRef.current === controller) {
      apiControllerRef.current = null;
    }

    if (sessionId === fetchSessionRef.current && !isAbandoned.current) {
      if (firstLoad.current) {
        _dispatch(setIdle());
        firstLoad.current = false;
      }
      setIsLoadingList(false);
    }

    isFetching.current = false;
  }
}

  async function initSpin(memberSpinWheelId) {
    if (isRewardClaimModalOpen) {
      setIframeSrc("");
    }
    _dispatch(setBusy());
    setIsLoadingBtn(memberSpinWheelId);

    let responseJson = await ApiEngine.post(
      ApiUrl._API_IMREWARD_SPIN,
      {
        "memberSpinWheelId": memberSpinWheelId,
      }
    );

    _dispatch(setIdle());
    setIsLoadingBtn(false);

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      if (!stringIsNullOrEmpty(responseJson[ApiKey._API_DATA_KEY].url)) {
        setIframeSrc(responseJson[ApiKey._API_DATA_KEY].url);
        setIsRewardClaimModalOpen(true);
        _dispatch(setSpinWheelListModal(false));
      }
    } else {
      _dispatch(
        showMessage({
          type: AlertTypes._ERROR,
          content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
        })
      );
    }
  }


  function updatePageinationPageNum(pageValue) {
    setPaginationPageNum(prevValue => pageValue);
  }

  const closeRewardClaimModal = () => {
    setIsRewardClaimModalOpen(false);
    setIframeSrc("");
    _dispatch(setSpinWheelListModal(true));
  };

  const calculateTimeLeft = (expiryDate) => {

    if (!expiryDate) {
      return "N/A";
    }

    const expiryDateWithUtc = expiryDate.endsWith("Z") ? expiryDate : expiryDate + "Z"; // John - We are already storing UTC time in the database, but we need to add the suffix to prevent it from changing to a "15 hours remaining" time.
    const now = new Date();
    const expiry = new Date(expiryDateWithUtc);
    // console.log("Now date -", now.toISOString())
    // console.log("Old expiry -", expiryDateAddedUtcLabel)
    // console.log("New expiry - ", expiry.toISOString())

    if (isNaN(expiry.getTime())) {
      return "-";
    }

    const diff = expiry - now;

    if (diff <= 0) {
      return (`0${t("DAY")}`).toLowerCase();
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    const parts = [];

    if (days > 0) {
      const dayLabel = days === 1 ? t("DAY") : t("DAYS");
      parts.push(`${days}${dayLabel}`);
    }

    if (hours > 0) {
      const hourLabel = hours === 1 ? t("HR") : t("HRS");
      parts.push(`${hours}${hourLabel}`);
    }

    if (minutes > 0) {
      const minuteLabel = minutes === 1 ? t("MIN_") : t("MINS");
      parts.push(`${minutes}${minuteLabel}`);
    }

    return parts.join(" ").toLowerCase();
  };
  return (
    <div>

      <Modal
        id="t3-custom-modal"
        className="modal-custom-fullscreen"
        contentClassName={"t3-custom-modal t3-custom-modal-with-back-btn min-height-600px spinwheel-modal"}
        ref={modalBodyRef}
        fade={false}
        isOpen={spinWheelListModal}
        toggle={() => {
          _dispatch(setSpinWheelListModal(false));
        }}
      >
        <ModalHeader>
          <div className="first">
            <div>{rewardType.name}</div>
          </div>
          <div className="second">
            <div
              className="t3-close-custom-modal"
              onClick={() => {
                _dispatch(setSpinWheelListModal(false));
              }}
            >
              <VIcon icon={themeIcons.close} className="vicon" />
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="p-0">
          <div className="t3-custom-modal-container">
            <div className="custom-body edit-profile" >
                <div className="spin-wallet-container">
                  <div className="wallet-row">
                    <div className="wallet-info" style={{ alignSelf: "start" }}>
                      <img
                        src={coinIcon}
                        style={{ width: "50px", height: "50px" }}
                        alt="img-wallet-coin"
                      />
                      <div>
                        <div> {`${t("WALLET_BALANCE")}:`}</div>
                        <div
                          style={{
                            fontWeight: "Bold",
                            color: "var(--base-main-button)",
                          }}
                            >
                            {oneWallet && isPromoActive
                                ? numberWithCurrencyFormat(walletsDetails.bonusWalletBalance, 2, true)
                                : numberWithCurrencyFormat(walletsDetails.currentWalletBalance, 2, true)
                            }
                          
                        </div>
                      </div>
                    </div>
                    <button
                      className="t3-custom-light-btn record-button"
                      onClick={() => {
                        _dispatch(setSpinWheelReportModal(true));
                        _dispatch(setSpinWheelListModal(false));
                      }}
                    >
                      {/* <img
            src={require("../../../assets/img/new_icons/record.svg")}
            alt="img-wallet"
              /> */}
                      <VIcon
                        icon={themeIcons.unionIcon}
                        className="theme-icon-size-20"
                      />
                      <span>{t("RECORD")}</span>
                    </button>
                  </div>
                </div>
                <div className="t3-alink" style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "20px 0px",
                  textDecoration: "none"
                }}>
                  <VIcon
                    icon={themeIcons.refreshTime}
                    className="theme-icon-size-20"
                  />
                  <span>{t("REWARD_REMINDER")}</span>
                </div>


              {isLoadingList &&
                <div className="t3-spinwheel-token-item loading" style={{ borderBottom: "none" }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <Spinner animation="border" size="lg" style={{ color: "var(--base-main-button)" }} />
                  </div>
                </div>
              }
              {!isLoadingList && spinWheelList && spinWheelList.length > 0 && (
                <> <div className="spin-wheel-card-container">
                  {spinWheelList.map((item, index) => (
                    <div className="spin-wheel-card" key={index}>
                      <div className="spin-wheel-title">
                        {`${t("REWARD")} #${item.id}`}
                      </div>
                      <div>
                        {`${t("CAMPAIGN")}: ${item.campaignName}`}
                      </div>
                      <div className="time-container">
                        <i className="fa fa-clock vicon" ></i>
                        <span>
                          {
                            item.expiryDateTxt==="N/A"?t("NO_EXP"):
                            `${t("EXPIRES_IN")}: ${t(item.expiryDateTxt)}`
                          }
                        </span>
                      </div>
                      {
                        item.status == "Unavailable" ?  (<button
                            className="t3-spinwheel-token-spin"
                            disabled={true}
                          >
                            <div>{t("UNAVAILABLE")}</div>
                          </button>) : 
                          <>
                            {item.completedAt == null ? (
                              isLoadingBtn == item.id ?
                                <div className="t3-spinwheel-token-spin" style={{ opacity: "0.5", width: "100%" }}>
                                  <Spinner animation="border" size="sm" />
                                </div>
                                :
                                <button
                                  className={`t3-spinwheel-token-spin ${ buttonDisabledCheck(heartBeat, oneWallet, walletsDetails, isPromoActive) ? 'promotion-disabled' : ''}`}
                                  onClick={() => {
                                    if(walletsDetails.forceWithdraw && oneWallet) {
                                        _dispatch(
                                            showMessage({
                                                type: AlertTypes._WARNING,
                                                content: t("FORCE_WITHDRAW_WARNING"),
                                            })
                                        );
                                    }
                                    else if (oneWallet && isPromoActive) {
                                        _dispatch(
                                            showMessage({
                                                type: AlertTypes._WARNING,
                                                content: t("PLEASE_END_PROMOTION_TO_CONTINUE"),
                                            })
                                        );
                                    } else {
                                      initSpin(item.id)
                                        // setIsModalOpen(!isModalOpen);
                                    }
                                  }}
                                >
                                  <div>{t("CLAIM_NOW")}</div>
                                </button>

                              ) : (
                                <div className="t3-spinwheel-token-spin completed">
                                  {t("COMPLETED_ON")} <span>{moment(item.completedAt).format("DD MMM YYYY, hh:mm A")}</span>
                                </div>
                              )}
                            </>
                        }
                      

                      </div>
                    ))}
                  </div>

                    {paginationPageNum > 1 && (
                        <PaginationBar
                          totalPages={paginationPageNum}
                          retrieveDataRecords={(page)=>{
                            pageReqCache.current=page;
                            getMySpins(rewardType.id,page);
                            setIsLoadingList(true);
                          }}
                          currentPageProp={pageReqCache.current}
                          isResetCurrentPage={isResetCurrentPage}
                          setIsChangeTab={setIsResetCurrentPage}
                        />
                    )}
                  </>
                )}


                {!isLoadingList && spinWheelList && spinWheelList.length == 0 && (
                <div className="t3-spinwheel-token-item empty" style={{ border: "none" }}>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <img
                      src={emptyPromoIcon}
                      alt="img-promo-empty"
                    // style={{ height: "230px",width:"300px" }}
                    />
                    <div className="text-center">{t("NO_SPIN_WHEEL_TOKENS")}</div>
                  </div>
                </div>
                )}

            </div>
          </div>
          
        </ModalBody>
      </Modal>

      <Modal
        id="t3-custom-modal"
        className="modal-custom-fullscreen spinwheel-claim-modal"
        contentClassName={"t3-custom-modal t3-custom-modal-with-back-btn min-height-600px spinwheel-modal"}
        fade={false}
        isOpen={isRewardClaimModalOpen}
        toggle={closeRewardClaimModal}
      >
        <ModalHeader>
          <div className="first">
            <div>{rewardType.name}</div>
          </div>
          <div className="second">
            <div
              className="t3-close-custom-modal"
              onClick={closeRewardClaimModal}
            >
              <VIcon icon={themeIcons.close} className="vicon" />
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="p-0">
          {iframeSrc && (
            <div className="t3-custom-modal-container">
              <div id="spin-wheel-iframe-container">
                <iframe
                  src={iframeSrc}
                  title="Spin Wheel"
                  id="spin-wheel-iframe"
                ></iframe>
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
      <SpinWheelClaimRecordPopUp />
    </div>

  );
};

export default SpinWheelListPopUpModal;
